<ng-container *transloco="let convert;">
  <div class="border border-dark batch-posting-shell">
    <div class="wrapper">
      <div class="header">
        <h2 class="fw-bold" tabindex="0" data-test-id="app-csv-dashboard-widget-e-header-text">{{convert('sellModule.manageInventory.csvDashBoardTranslations.textFileProcessing')}}</h2>
      </div>
    </div>
    <form class="body" name="dashBoardForm" [formGroup]="dashBoardForm">
      <div>
        @if (appLoading) {
          <div class="d-flex justify-content-center align-items-center spinner-container tab-spinner-height mb-3">
            <app-spinner></app-spinner>
          </div>
        }
      </div>
      <div class="d-flex date-range">
        <div class="flex-fill">
          <div class="datepicker-group">
            <div class="form-group date-label mb-0">
              <label class="control-label">{{convert('sellModule.manageInventory.csvDashBoardTranslations.textUploadedDate')}}</label>
            </div>
            <div class="flex-grow-1">
              <div class="form-group d-flex date-group">
                <input
                  type="text"
                  id="fromDate"
                  class="form-control form-input"
                  [formControl]="fromFormControl"
                  [class.is-invalid]="!fromDateValid"
                  #fromDp="ngbDatepicker"
                  ngbDatepicker
                  (dateSelect)="updateFromDate($event)"
                  [value]="displayFromDate"
                  #dpFromDate
                  (input)="updateFromDate(dateFormatter.parse(dpFromDate.value))"
                  [minDate]="fromMinDate"
                  [maxDate]="fromMaxDate"
                  [startDate]="fromStartDate"
                  (change)="resetFileNote"
                  container="body"
                  [attr.aria-label]="convert('sellModule.manageInventory.csvDashBoardTranslations.ariaLabelFileUploadedDate')"
                  [placeholder]="dateFormatter.placeholderText()"
                  (closed)="focusFromCalendar()"
                  maxlength="10"
                  minlength="10"
                  [appTrack]="fileUploadedDateTrack.input"
                  />
                <button
                  #fromCalendar
                  class="btn btn-outline-primary calendar-button"
                  (click)="fromDp.toggle()"
                  [attr.aria-expanded]="fromDp.isOpen()"
                  [attr.aria-label]="convert('sellModule.manageInventory.csvDashBoardTranslations.ariaLabelFileUploadedDate')"
                  [style.border-color]="!fromDateValid ? 'red' : ''"
                  [appTrack]="fileUploadedDateTrack.button"
                  >
                  <i class="allycon-calendar" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="error-message from-date-error" aria-atomic="true" aria-live="polite" role="alert">
            @if (!fromDateValid) {
              <div><strong>{{convert('sellModule.manageInventory.csvDashBoardTranslations.textEnterValidFileUploadedDate')}}</strong></div>
            }
          </div>
        </div>
      </div>
      <br>
        <div class="form-group date-label mb-0">
          <label class="control-label text-align-right">{{convert('sellModule.manageInventory.csvDashBoardTranslations.textFileName')}}</label>
        </div>
        <div class="row container mt-2 ms-1">
          <div class="col-md-6">
            <div class="form-group">
              <div class="select-wrapper">
                <select formControlName="uploadedFile" id="uploadedFile" class="custom-select wrapText" aria-label="selectUploadedFile" (change)="setSelectedFile()">
                  <option [ngValue]="'default'">{{convert('sellModule.posting.descriptionForm.textSelect')}}</option>
                  @if (fileList) {
                    @for (file of fileList; track file) {
                      <option [ngValue]="file.fileName">{{file.fileName}}</option>
                    }
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
        @if (fileSelected) {
          <div class="text-align-right">
            @if (!resetFileStatus) {
              <span class="wrap-text">The File <strong>{{selectedFile.fileName}}</strong> has current status of <strong>{{selectedFile.status}}</strong></span>
            }
            <div class="py-3">
              <ng-container>
                <button
                  (click)="startFileProcessing()"
                  allytm-click-tagged="false"
                  [disabled]="disableProcessingFile"
                  [ngClass]="{ 'disabled-button':disableProcessingFile}"
                  data-test-id="app-batch-posting-shell-e-upload-button"
                  class="upload-button">
                  {{convert('sellModule.manageInventory.csvDashBoardTranslations.textProcessFile')}}
                </button>
              </ng-container>
            </div>
            <div>
              @if (fileProcessing === true) {
                <div class="body d-flex flex-column align-items-start">
                  <span><strong>{{convert('sellModule.manageInventory.csvDashBoardTranslations.textFileInProgress')}}</strong></span>
                </div>
              }
              <app-error-modal></app-error-modal>
            </div>
          </div>
        }
      </form>
    </div>
    @if (fileSelected) {
      <div>
        <br>
          <app-csv-update-widget [selectedFile]="selectedFile"></app-csv-update-widget>
        </div>
      }
    </ng-container>
